
import { formatByCountry, resolveCountry } from "@/app/infrastructures/misc/Utils";
import { CodReconcileController } from "@/app/ui/controllers/CodReconcileController";
import { CourierHistory } from "@/domain/entities/CodReconcile";
import moment from "moment";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    histories: {
      type: Array as () => CourierHistory[],
      required: true
    }
  },
  emits: ["showModal", "showModalPreviewImage"],
})
export default class RiwayatSetor extends Vue {
  expanded = false;
  showModalStt(data: any) {
    this.$emit("showModal");
    CodReconcileController.setCourierDetailStt(data);
  }

  showModalPreviewImage(data: any) {
    this.$emit("showModalPreviewImage");
    CodReconcileController.setPreviewImageDetailStt(data);
  }

  // Props
  histories!: CourierHistory[];

  toggleExpand() {
    this.expanded = !this.expanded;
  }

  valueTime(dateTime: any) {
    return moment(dateTime).format("HH:mm");
  }

  get prefixCurrency() {
    return resolveCountry() === "MY" ? "RM" : "Rp";
  }

  formatDisplayAmount(amount: number) {
    return formatByCountry(amount, { type: "money", prefix: this.prefixCurrency });
  }
}
